module.exports = __webpack_public_path__ + "static/media/support.d2e0f0d2.svg";